import API from "./api";

class Sender {
  post(path, body, headers, ...kwargs) {
    // console.log(path, body, headers, ...kwargs)
    const url = path;
    return new Promise((resolve, reject) =>
      window.ws.send_request_post(
        {
          url,
          data: body || {},
          headers,
          success: resolve,
          failed: reject,
          ...kwargs
        }
        // this.jwt
      )
    );
  }
  restPost(path, body, headers, ...kwargs) {
    const config = { headers };
    return API.http.post(path, body, config).then(response => response.data);
  }
  restGet(path, params, headers, ...kwargs) {
    const config = { headers, params };
    return API.http.get(path, config).then(response => response.data);
  }
  restPatch(path, body, headers, ...kwargs) {
    const config = { headers }
    return API.http.patch(path, body, config).then(response => response.data)
  }
  restDel(path, params, headers, ...kwargs) {
    const config = { headers, params }
    return API.http.delete(path, config).then(response => response.data)
  }
}

export default new Sender();
